import type { Ref } from "vue";
import type { User } from "~/models/User";

export interface UseAppEcho {
    echo: ReturnType<typeof useEcho>;
    users: Ref<User[]>;
    channel: Ref<ReturnType<typeof useEcho>["join"]>;
}

export function useAppEcho(): UseAppEcho {
    const echo = useEcho();

    const { $authenticatedUsers, $authenticatedChannel } = useNuxtApp() as {
        $authenticatedUsers: UseAppEcho["users"];
        $authenticatedChannel: UseAppEcho["channel"];
    };

    return {
        echo,
        users: $authenticatedUsers,
        channel: $authenticatedChannel,
    };
}
